export const IaptLittleInterestOrPleasureInDoingThings = "IaptLittleInterestOrPleasureInDoingThings";
export const IaptFeelingDownDepressedOrHopeless = "IaptFeelingDownDepressedOrHopeless";
export const IaptTroubleFallingOrStayingAsleepOrSleepingTooMuch = "IaptTroubleFallingOrStayingAsleepOrSleepingTooMuch";
export const IaptFeelingTiredOrHavingLittleEnergy = "IaptFeelingTiredOrHavingLittleEnergy";
export const IaptPoorAppetiteOrOvereating = "IaptPoorAppetiteOrOvereating";
export const IaptFeelingBadAboutYourself = "IaptFeelingBadAboutYourself";
export const IaptTroubleConcentratingOnReadingOrWatching = "IaptTroubleConcentratingOnReadingOrWatching";
export const IaptMovingOrSpeakingSoSlowly = "IaptMovingOrSpeakingSoSlowly";
export const IaptThoughtsThatWouldBeBetterOffDeadOrOfHurtingYourself = "IaptThoughtsThatWouldBeBetterOffDeadOrOfHurtingYourself";
